import { classNames } from "@/shared/utils/classnames";
import { faClose } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useMemo, useState, type FC } from "react";

export type AttachmentPreviewProps = {
  url: string;
  ext: string;
  onRemove?: () => void;
};

export const AttachmentPreview: FC<AttachmentPreviewProps> = ({
  url,
  ext,
  onRemove,
}) => {
  const [isLoading, setIsLoading] = useState(true);

  return (
    <div
      className={classNames(
        `h-16 w-16 relative flex bg-gray-300 justify-center items-center`,
        isLoading ? "animate-pulse" : ""
      )}
    >
      <div
        className="absolute flex items-center justify-center text-white text-xs h-4 w-4 bg-red-500 -right-1 -top-1 rounded-full cursor-pointer"
        onClick={onRemove}
      >
        <FontAwesomeIcon icon={faClose} />
      </div>
      <img
        src={url}
        className="h-16 w-16 rounded-md"
        onLoad={() => setIsLoading(false)}
      />
    </div>
  );
};
